import { StepUtils } from '@marvelapp/user-test-creator';
export function stepSupportsOpenAI(step) {
    return StepUtils.isTextStep(step);
}
